import classnames from 'classnames';
import React, { useEffect } from 'react';
import { FontIconBtn } from '@meitu/saas-ui';
import { getRenderNode, OptionType } from '../type';

export const AsideBtn: React.FC<{ isShowCollapse: boolean; onClick: () => void }> = ({ isShowCollapse, onClick }) => {
    return (
        <div
            className={classnames('p-editor__aside-btn', {
                active: isShowCollapse,
            })}
        >
            <div onClick={() => onClick()} className={classnames('p-editor__aside-btn-icon')}>
                <div
                    className={classnames('p-editor__aside-btn-icon-pos', {
                        rotate: isShowCollapse,
                    })}
                >
                    <FontIconBtn name="ChevronRightBlack" fontSize={12} />
                </div>
            </div>
        </div>
    );
};

const Stage: React.FC<{
    children?: React.ReactNode;
    isShowCollapse?: boolean;
    isShowAsideBtn?: boolean;
    onClick?: () => void;
    onResize?: (width: number, height: number) => void;
}> = ({ children, isShowCollapse = true, isShowAsideBtn = true, onResize, onClick }) => {
    const stageRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                onResize?.(width, height);
            }
        });

        if (stageRef.current) {
            resizeObserver.observe(stageRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const cols1 = getRenderNode(OptionType.cols1);

    return (
        <div ref={stageRef} className="p-editor__stage-wrap">
            <div className="p-editor__stage">
                <div className="p-editor__stage-content">
                    {isShowAsideBtn ? <AsideBtn isShowCollapse={isShowCollapse} onClick={() => onClick?.()} /> : null}
                    {children}
                    {cols1}
                </div>
            </div>
        </div>
    );
};

export default Stage;
